export const cookieKey = 'layout'

export enum Layout {
  NEW = 'new',
  OLD = 'old',
}
